import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-balance',
  templateUrl: './table-balance.component.html',
  styleUrls: ['./table-balance.component.scss'],
})
export class TableBalanceComponent implements OnInit {
  @Input() tableTitle: string;
  @Input() currency: string;
  @Input() balance = [];
  @Input() colours = [];
  max: number;
  //
  constructor() {}

  ngOnInit() {
    this.max = this.setMax();
  }

  showMore() {
    this.max = this.balance.length;
  }

  showMinus() {
    this.max = this.setMax();
  }

  setMax() {
    return this.balance.length >= 5 ? 3 : 5;
  }
}
